import { Mutation, Query } from "@/core/graphql/graphql";

export type GeneratedMutation = Mutation;

export type GeneratedQuery = Query;

type Meta = { nextPageCursor?: string | undefined | null };

type Selector<T,V> = (x: V) => { items: T[], meta: Meta};

/* I recommend using 199 as page size as it's the largest possible for now 06.2021 */
type query<V> = (nextCursor: string | undefined) => Promise<V>;

export async function getAllWithoutPagination<T,V>(query: query<V>, select: Selector<T,V>): Promise<T[]> {
  const result:T[] = [];
  let nextCursor: string | undefined;
  do {
    const { items, meta } = await getOneBatch(query, select, nextCursor);
    nextCursor = meta.nextPageCursor ?? undefined;
    result.push(...items);
  } while (nextCursor);
  return result;
}

async function getOneBatch<T,V>(query: query<V>,
  select: Selector<T,V>,
  nextCursor: string | undefined)
    : Promise<{ items: T[], meta: Meta }> {
  const result = await query(nextCursor);
  return select(result);
}
